import { css } from '@/styled-system/css';

export const datePickerButtonGroupStyles = css.raw({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: 'auto',
  display: 'flex',
  justifyContent: 'flex-end',
});
